module.exports = __webpack_public_path__ + "img/f6.bae7a3a6.jpg";